import { FunctionComponent } from 'react';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';
import { AlertNewBooking } from './AlertNewBooking';
import styles from './SessionFullAlert.module.scss';

interface Props {
    serviceName?: string;
    // Smaller variant shown under a session card.
    compact?: boolean;
}

export const SessionFullAlert: FunctionComponent<Props> = ({ serviceName, compact }) => (
    <div id="booking_div_session_full_alert">
        <AlertNewBooking
            className={clsx(styles.alert, { [styles.compact]: compact })}
            bWidth="2px"
            icon={faExclamationTriangle}
            iconSize={compact ? 'sm' : 'lg'}
            iconColor="#EAB464"
            bgColor="#F8F5F1"
            bdColor="#BCB8AE"
        >
            <span className={styles.alertText}>
                <b>{serviceName}</b> is full, but you can still select it.
            </span>
        </AlertNewBooking>
    </div>
);

export default SessionFullAlert;
